export default __webpack_public_path__ + "static/arindamLehri12-2cd3e1c95fcd3f663005677c40857e04.jpg";